function Border() {

    this.name = 'border';
}

export {Border};
